exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__container___18mVM{max-width:300px;margin:20px auto}.style__error___2hG6G{color:#ff8787;margin-bottom:10px;text-align:center}.style__forgot___3vqFB{font-family:Poppins-Light;font-weight:300;letter-spacing:.2px;text-align:center;font-size:14px}.style__forgot___3vqFB a{color:#d7887c;text-decoration:underline}", ""]);

// exports
exports.locals = {
	"container": "style__container___18mVM",
	"error": "style__error___2hG6G",
	"forgot": "style__forgot___3vqFB"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/containers/login/style.css
// module id = 727
// module chunks = 0